import {Dispatch} from "redux";
import {appLink} from "@web2/gh_routes";

import {IRouteState} from "../../app/routes/data_fetcher/create_app_path_data_fetcher";
import {IServices} from "../../app/services/IServices";
import {ghCommonUrl} from "../../app/utils/read_environment_variables";
import {updateMetaData} from "../../meta_data/actions/update_meta_data";

export const updateAuthorListMetaData = (_1: Partial<IServices>, route: IRouteState<{}>) => (dispatch: Dispatch) => {
    const title = `Autorzy - dziennikarze i eksperci bloga GetHome.pl`;
    const description = `Sprawdź profile autorów artykułów portalu GetHome.pl. Zobacz, kto pisze treści na naszym blogu.`;
    const robots = "index, follow";
    const canonical = `${ghCommonUrl}${appLink.article.author.base()}`;

    dispatch(updateMetaData(title, description, route, {robots, canonical}));

    return Promise.resolve(true);
};
